import { cn } from "@/utils/cn"

type TabStyleProps = {
  isActive?: boolean
  isFirst?: boolean
  disabled?: boolean
}

export const getTabsWrapperStyles = () => {
  return cn("relative flex w-full items-center gap-[10px] py-[8px] pr-[12px]")
}

export const getWrapperBackgroundStyles = () => {
  return cn("absolute top-0 h-full w-full skew-x-[-40deg] rounded-[4px] bg-dark px-[10px]")
}

export const getTabStyles = ({
  isActive = false,
  isFirst = false,
  disabled = false,
}: TabStyleProps) => {
  return cn(
    "group relative inline-flex items-center justify-center",
    "h-[24px] px-[32px]",
    "font-bold text-dark-100",
    "transition-all duration-150",
    "focus-visible:z-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400",
    {
      "text-primary-100": isActive,
      "text-dark-400": disabled,
      "ml-[12px]": isFirst,
    }
  )
}

export const getTabBackgroundStyles = ({ isActive, disabled }: TabStyleProps) => {
  return cn(
    "pointer-events-none absolute inset-0 z-10 h-full w-full skew-x-[-40deg] rounded-bl-[4px] rounded-br-[2px] rounded-tl-[2px] rounded-tr-[4px] bg-dark transition-colors group-hover:bg-dark-400",
    {
      "bg-primary group-hover:bg-primary": isActive,
      "bg-dark-300 opacity-30 group-hover:bg-dark-300": disabled,
    }
  )
}

export const getTabLabelStyles = () => {
  return cn("z-20 text-[12px]")
}
